// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-container .button-container-button[data-v-c5a7a714]{padding:0!important}.button-container .button-container-button[data-v-c5a7a714] .v-btn__content{font-weight:600}", ""]);
// Exports
module.exports = exports;
